<div [chart]="chartObject" (click)="chartClick($event)"></div>